<template>
  <div class="main-wrapper" style="min-height: 100%;">
    <el-tree
      :data="treeData"
      :props="{label:'menuName'}"
      node-key="id"
      default-expand-all
      @node-drop="handleDrop"
      @node-click="onNodeClick"
      draggable
      :expand-on-click-node="false"
      :allow-drag="allowDrag">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span class="tree-btn">
              <el-button
                type="text"
                size="mini"
                @click="() => appendNode(data)">
                添加
              </el-button>
              <el-button
                v-if="data.parentId !== '0'"
                type="text"
                size="mini"
                @click="() => editNode(data)">
                编辑
              </el-button>
              <el-button
                v-if="data.parentId !== '0'"
                type="text"
                size="mini"
                @click="() => removeNode(data)">
                删除
              </el-button>
            </span>
          </span>
    </el-tree>
    <edit-modal :rowId="currentId"  :title="currentTitle" v-if="isShowEdit" @ok="onModalOk" @close="isShowEdit=false" :mode="editMode" :config="editConfig"></edit-modal>
  </div>
</template>
<script>
  import {getAction,postAction,putAction,deleteAction} from "@/service/http/api";
  import pageMixin from "@/mixin/tablePage"
  import menuTreeMixin from "@/mixin/menuTree"
  import editModal from "./edit"
  import common from '@/service/common'

  export default {
    name:'PermissionManagement',
    mixins:[pageMixin,menuTreeMixin],
    components:{
      'edit-modal':editModal
    },
    data(){
      return{
        treeData:[],
        currentId:null,
        isShowEdit:false,
        currentTitle:'新增菜单',
        editMode:'new',
        editConfig:{
          parentId:null,
          sortNo:1
        },
        url:{
          list:'/permission/list',
          remove:'/permission/deleteById',
          edit:'/permission/edit',
        }
      }
    },
    methods:{
      allowDrag(draggingNode) {
        return draggingNode.data.parentId !== '0';
      },
      onNodeClick(data){
        console.log(data);
      },
      /**
       * 加载数据
       */
      loadData() {
        this.getTree();
      },
      handleDrop(draggingNode, dropNode, dropType) {
        debugger
        let row = Object.assign({},draggingNode.data);
        if(dropType==='before'||dropType==='after'){
          let pData = dropNode.parent.data;
          let index = pData.children.findIndex(men=>{
            return men.id === draggingNode.data.id;
          });
          row.parentId = pData.id;
          if(dropType==='before'){
            if(index==0){
              row.sortNo = common.floatObj.divide(dropNode.data.sortNo,2);
            }else{
              let sum = common.floatObj.add(pData.children[index-1].sortNo,dropNode.data.sortNo);
              row.sortNo = common.floatObj.divide(sum,2);
            }
          }else{
            if(index===pData.children.length-1){
              row.sortNo = common.floatObj.add(dropNode.data.sortNo,100);
            }else{
              let ss = common.floatObj.add(dropNode.data.sortNo,pData.children[index+1].sortNo);
              row.sortNo = common.floatObj.divide(ss,2);
            }
          }
        }else if(dropType==='inner'){
          row.parentId = dropNode.data.id;
          let pData1 = dropNode.data;
          if(pData1.children&&pData1.children.length>1){//当前拖动进来的已经在了
            row.sortNo = common.floatObj.add(pData1.children[pData1.children.length-2].sortNo,100);
          }else{
            row.sortNo = 100
          }
        }
        this.saveNode(row);
      },
      appendNode(data){
        this.editConfig.parentId = data.id;
        if(data.children && data.children.length>0){
          this.editConfig.sortNo = common.floatObj.add(data.children[data.children.length-1].sortNo,100);
        }else{
          this.editConfig.sortNo = 100;
        }
        this.addModal('新增菜单')
      },
      editNode(data){
        this.editConfig.parentId = data.parentId;
        this.editConfig.sortNo = data.sortNo;
        this.currentTitle = '编辑' + data.menuName;
        this.editModal(data);
      },
      removeNode(data){
        this.$confirm('此操作将永久删除该菜单, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          getAction(this.url.remove,{id:data.id}).then(res=>{
            if(res.code===200){
              this.$message({
                message:'删除成功',
                type:"success"
              });
              this.loadData();
            }
          })
        })
      },
      saveNode(row){
        putAction(this.url.edit,row).then(res=>{
          if(res.code===200){
            this.$message({
              message:'保存成功',
              type:"success"
            });
          }
          this.loadData();
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .content-list{
    position: absolute;
    border: 1px solid red;
    /*z-index: 999;*/
    li{
      color: #000;
    }
  }
  .custom-tree-node{
    .tree-btn{
      display: none;
    }
  }
  .el-tree-node__content:hover{
    .tree-btn{
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/permession_management/permession_management.vue